import React from 'react';
import { BsFileFill, BsFilePdfFill, BsImageFill } from 'react-icons/bs';

import { Box } from '@qwealth/qcore';
import { S3Item } from '@qwealth/qvault';

import { StyledDocumentButton } from './KypDocument.styled';

const truncateFilename = (filename: string, maxBaseLength: number): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) return filename;

  const base = filename.slice(0, lastDotIndex);
  const ext = filename.slice(lastDotIndex);

  if (base.length <= maxBaseLength) return filename;

  return base.slice(0, maxBaseLength) + '... ' + ext;
};

const getJsxIconForFileExtension = (fileExtension: string): JSX.Element => {
  switch (fileExtension) {
    case 'pdf':
      return <BsFilePdfFill size={24} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
    case 'svg':
    case 'ico':
      return <BsImageFill size={24} />;

    default:
      return <BsFileFill size={24} />;
  }
};

interface KypDocumentButtonProps {
  attachment: S3Item;
  clickAttachment: (name: string, fileName: string, type: string) => void;
}

// ToDo: Make a single component for all document previews
const KypDocumentButton: React.FC<KypDocumentButtonProps> = ({ attachment, clickAttachment }) => {
  const attachmentUrl = attachment.key;
  const attachmentName = attachmentUrl ? attachmentUrl.split('/').pop() : '';
  const attachmentType = attachmentName ? attachmentName.split('.').pop() : '';
  const attachmentIcon = getJsxIconForFileExtension(attachmentType ? attachmentType : '');
  const formattedAttachmentName = truncateFilename(attachmentName ? attachmentName : '', 40);

  const clickPreview = () => {
    if (attachmentUrl && attachmentName && attachmentType) {
      clickAttachment(attachmentUrl, attachmentName, attachmentType);
    }
  };

  return (
    <StyledDocumentButton onClick={clickPreview}>
      <Box display="flex" flexDirection="row" padding="default" alignItems="center" gap="large">
        {attachmentIcon}
        {formattedAttachmentName}
      </Box>
    </StyledDocumentButton>
  );
};

export default KypDocumentButton;
